<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="table_data.search"/>
      <v-spacer/>
      <v-toolbar-items style="height: auto">
        <v-select label="Study group"
                  v-model="table_data.study_group_id"
                  :items="study_groups"
                  item-value="id"
                  item-text="name"
                  hide-details
                  outlined
                  dense
                  clearable
        ></v-select>
      </v-toolbar-items>
<!--      <v-btn class="ml-3 box-shadow" color="primary" @click="toSearchPage">Invite new</v-btn>-->
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="table_data_items"
                      :search="table_data.search" dense>
          <template v-slot:item.study_groups="{ value }">
            <template v-for="(study_group, idx) in value">
              <p class="ma-0" :key="idx">{{ study_group.name }}</p>
            </template>
          </template>

          <template v-slot:item.session_limits="{ value }">
            <div v-for="(item, idx) in value" :key="idx">
              {{ item.short_name }} - {{ item.count }}
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <v-btn small :color="getBadgeColor(item.status)" @click="openSelectedItemDialog(item)">
              {{ item.status }}
            </v-btn>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" :to="{name: 'Student', params: {student_id: item.id}}">Open</v-btn>
<!--            <v-icon class="mr-2" @click="openSelectedItemDialog(item)">mdi-pencil</v-icon>-->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    table_data: {
      headers: [
        { text: 'ID', value: 'id'},
        { text: 'Name', value: 'full_name'},
        { text: 'Email', value: 'email'},
        { text: 'Nickname', value: 'nickname'},
        { text: 'Study groups', value: 'study_groups'},
        { text: 'Session limits', value: 'session_limits'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',
      study_group_id: null,
    },

    study_groups: [],
    packages: [],
    session_types: [],

    selected_item_dialog: false,
    selected_item: null,

    api_errors: [],
  }),
  computed: {
    table_data_items: function () {
      let items = []
      items.push(...this.table_data.items)

      if(this.table_data.study_group_id) {
        items = items.filter(user => user.study_groups.find(item => item.id === this.table_data.study_group_id))
      }

      return items
    }
  },
  created() {
    this.loadData()
    this.loadStudyGroups()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/students`).then(({data}) => data.data)
    },
    async loadStudyGroups() {
      this.study_groups = await this.axios.get(`api/study-groups`).then(({data}) => (data.data))
    },

    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    getBadgeColor(value) {
      switch (value) {
        case 'invited':
          return 'success'
        case 'requested':
          return 'red'
        default:
          return 'primary'
      }
    }
  }
}
</script>